import { MarkdownTab } from "../../../types/ContentfulTypes";

export interface SocialCurationsTabData {
  source: {
    id: string;
    type: string;
    tag: string;
  };
  widget: {
    instanceId: string;
    jsId: string;
  };
  apiKey: string;
  tabTitleEntryId: string;
  tabSubtitleEntryId: string;
  resolvedDictionaryEntries: { [key: string]: string };
}

export const renderSocialCuration = (tabData: SocialCurationsTabData | MarkdownTab | undefined) => {
  return (
    tabData &&
    tabData.apiKey &&
    tabData.source?.tag &&
    tabData.widget?.instanceId &&
    tabData.widget?.jsId &&
    tabData.tabTitleEntryId &&
    tabData?.resolvedDictionaryEntries?.[tabData?.tabTitleEntryId]
  );
};
